import React, { useState, useEffect } from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Container from './Container';

const useStyles = createUseStyles(({
  rem,
}) => ({
  root: {
    display: 'none',
    position: 'fixed',
    top: 0,
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    zIndex: 99,
  },
  bars: {
    width: '100%',
    height: 60,
    fontSize: rem(14),
    boxShadow: '0px 8px 14px 4px rgba(13, 38, 91, 0.02), 0px 6px 8px 0px rgba(13, 38, 91, 0.04), 0px 3px 3px -2px rgba(13, 38, 91, 0.06)',
  },
  anchor: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '25%',
    height: 60,
    color: '#000 !important',
    textDecoration: 'unset',
    cursor: 'pointer',
    textAlign: 'center',
  },
  curr: {
    fontWeight: 'bold',
    borderBottom: '3px solid #57BCF9',
  },
  show: {
    display: 'block',
    transition: 'all 0.5s',
  },
}), {
  name: 'HeaderBar'
})

const HeaderBar = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const { t } = props;
  let once = 0;

  const [curr, setCurr] = useState('product');
  const [isShow, setIsShow] = useState(false);
  const [currScTop, setCurrScTop] = useState(0);
  const [titles, setTitles] = useState([]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleScroll = () => {
    let scrollTop = global.window.pageYOffset;
    if (scrollTop >= 150) {
      setIsShow(true);
    } else if (scrollTop < 140) {
      setIsShow(false);
    }
    setCurrScTop(scrollTop);
    handleLoad(scrollTop);
  };

  // 标题监听，当标题进入视窗时进行标记
  const titleObserver = (top) => {
    if (top) {
      if (top < titles[0]) {
        setCurr('product');
      } else if (top > titles[0] && top < titles[1]) {
        setCurr('details');
      } else if (top > titles[1] && top < titles[2]) {
        setCurr('trac');
      } else if (top > titles[titles.length - 1]) {
        setCurr('brand');
      }
    }
  }

  useEffect(() => {
    if (currScTop) {
      titleObserver(currScTop);
    }
  }, [currScTop]);

  const handleLoad = (top) => {
    // 只计算一次
    if (top > 0 && once === 0) {
      const arr = [];
      const titles = ['details', 'trac', 'brand'];
      titles.forEach(item => {
        // 元素距离视窗高度
        let elementById = global.document.getElementById(item);
        if (elementById && elementById.getBoundingClientRect()) {
          const scTop = elementById.getBoundingClientRect().top - 70;
          arr.push(scTop);
        }

      });
      once = 1;
      setTitles(arr);
    }
  }

  useEffect(() => {
    global.window.addEventListener('scroll', handleScroll);
    global.window.addEventListener('touchmove', handleScroll); // 安卓
  }, []);

  // 锚点功能，没有使用 a 锚点，因为会覆盖部分内容
  const handleClick = (id) => {
    const ele = global.document.getElementById(id);
    const anHeight = ele.offsetTop - 70;
    global.window.scrollTo(0, anHeight);
    setCurr(id);
  }

  return (
    <Container className={classNames(classes.root, isShow && classes.show)}>
      <Container
        flex
        justify='space-around'
        alignItems='center'
        className={classNames(classes.bars)}
      >
        <p
          onClick={() => handleClick('product')}
          className={classNames(classes.anchor, curr === 'product' && classes.curr)}
        >
          <span>{t('product')}</span>
        </p>
        <p
          onClick={() => handleClick('details')}
          className={classNames(classes.anchor, curr === 'details' && classes.curr)}
        >
          <span>{t('details')}</span>
        </p>
        <p
          onClick={() => handleClick('trac')}
          className={classNames(classes.anchor, curr === 'trac' && classes.curr)}
        >
          <span>{t('traceability')}</span>
        </p>
        <p
          onClick={() => handleClick('brand')}
          className={classNames(classes.anchor, curr === 'brand' && classes.curr)}
        >
          <span>{t('brand')}</span>
        </p>
      </Container>

    </Container>
  )
};

HeaderBar.propTypes = {
  t: PropTypes.func.isRequired,
}

export default HeaderBar;
